import { ScholarshipSessionDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadScholarshipSession = createAction(
  '[ScholarshipSession] Load ScholarshipSession'
);

export const loadScholarshipSessionSuccess = createAction(
  '[ScholarshipSession] Load ScholarshipSession Success',
  props<{ scholarshipSession: ScholarshipSessionDto[] }>()
);

export const loadScholarshipSessionFailure = createAction(
  '[ScholarshipSession] Load ScholarshipSession Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addScholarshipSession = createAction(
  '[ScholarshipSession] Add ScholarshipSession',
  props<{ newScholarshipSession: ScholarshipSessionDto[] }>()
);

export const addScholarshipSessionSuccess = createAction(
  '[ScholarshipSession] Add ScholarshipSession Success',
  props<{ newScholarshipSession: ScholarshipSessionDto[] }>()
);

export const addScholarshipSessionFailure = createAction(
  '[ScholarshipSession] Add ScholarshipSession Failure',
  props<{ error: any }>()
);

/**
 * Update ScholarshipSession Collection Actions
 */
export const updateScholarshipSession = createAction(
  '[ScholarshipSession] Update ScholarshipSession',
  props<{ updateScholarshipSession: ScholarshipSessionDto[] }>()
);

export const updateScholarshipSessionSuccess = createAction(
  '[ScholarshipSession] Update ScholarshipSession Success',
  props<{ updateScholarshipSession: ScholarshipSessionDto[] }>()
);

export const updateScholarshipSessionFailure = createAction(
  '[ScholarshipSession] Update ScholarshipSession Failure',
  props<{ error: any }>()
);

/**
 * Remove ScholarshipSession Collection Actions
 */
export const removeScholarshipSession = createAction(
  '[ScholarshipSession] Remove ScholarshipSession',
  props<{ ids: string[] }>()
);

export const removeScholarshipSessionSuccess = createAction(
  '[ScholarshipSession] Remove ScholarshipSession Success',
  props<{ ids: string[] }>()
);

export const removeScholarshipSessionFailure = createAction(
  '[ScholarshipSession] Remove ScholarshipSession Failure',
  props<{ error: any }>()
);
